import usePolledSwrAsComplexState from '@/lib/api/usePolledSwrAsComplexState';
import { type Tag } from '@/lib/types';
import TagsContext from './TagsContext';
import CreateTag from './CreateTag';
import TagWithControls from './TagWithControls';
import TagsManagerWrapper from './TagsManagerWrapper';
import TagsWrapper from './TagsWrapper';
import NoTagsMessage from './NoTagsMessage';
import TagsLoadingState from './TagsLoadingState';
import { FormattedMessage } from 'react-intl';
import sortByCreatedAt from '@/lib/utils/sorting/sortByCreatedAt';

const TagsManager = () => {
  const [loading, tags, setTags] =
    usePolledSwrAsComplexState<Record<number, Tag>>('tags');

  if (loading) {
    return <TagsLoadingState />;
  }

  return (
    <TagsContext.Provider value={[tags, setTags]}>
      <TagsManagerWrapper>
        <h3>
          <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.title" />
        </h3>
        {Object.values(tags).length === 0 ? (
          <NoTagsMessage />
        ) : (
          <TagsWrapper>
            {Object.values(tags)
              .sort(sortByCreatedAt)
              .map(tag => (
                <TagWithControls tag={tag} key={tag.id} />
              ))}
          </TagsWrapper>
        )}
        <CreateTag />
      </TagsManagerWrapper>
    </TagsContext.Provider>
  );
};

export default TagsManager;
